<mat-nav-list>
    <a mat-list-item (click)="markResolved($event)">
      <span mat-line>Mark Answered</span>
    </a>
  
    <a mat-list-item (click)="markUnresolved($event)">
      <span mat-line>Mark Unanswered</span>
    </a>
  
    <a mat-list-item (click)="notify($event)">
      <span mat-line>Notify Student</span>
    </a>
    <a *ngIf="!!data.conversation?.originalQuestion" mat-list-item (click)="forward($event)">
      <span mat-line>Forward to Pastor</span>
    </a>
    <a  mat-list-item (click)="archive($event)">
      <span mat-line>Archive</span>
    </a>
</mat-nav-list>